import html2canvas from 'html2canvas';

type DownloadFormat = 'png' | 'jpg';

interface DownloadOptions {
  format?: DownloadFormat;
  quality?: number;
  filename?: string;
}

export async function downloadQuoteCard(
  element: HTMLElement,
  options: DownloadOptions = {}
): Promise<void> {
  const { format = 'png', quality = 0.95, filename = 'quote' } = options;

  const canvas = await html2canvas(element, {
    backgroundColor: null,
    scale: 2,
    useCORS: true,
    logging: false,
  });

  const mimeType = format === 'jpg' ? 'image/jpeg' : 'image/png';
  const q = format === 'jpg' ? quality : undefined;

  canvas.toBlob(
    (blob) => {
      if (!blob) return;
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${filename}.${format}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    mimeType,
    q
  );
}

export async function downloadQuoteAsImage(
  element: HTMLElement,
  filename: string,
  format: DownloadFormat = 'png'
): Promise<void> {
  return downloadQuoteCard(element, { format, filename });
}
